import { combineReducers } from 'redux';

import { htmlEntitiesDecode } from '@x_x_x/utils';

import { auth, getAuthInitialState } from './Auth';
import { IState } from './IState';
import { menu, getMenuInitialState } from './Menu';
import { menuCatalog, getMenuCatalogInitialState } from './MenuCatalog';
import { targets, getTargetsInitialState } from './Targets';

export type { IState };

export * from './Auth';
export * from './BodyDimensionsLog';
export * from './Menu';
export * from './MenuCatalog';
export * from './StepsLog';
export * from './Targets';
export * from './WeightLog';
export * from './PhotoLog';

export const rootReducer = combineReducers({
	auth,
	targets,
	menu,
	menuCatalog,
});

let initialState: IState;

try {
	initialState = JSON.parse(htmlEntitiesDecode(document.getElementById('initial-state').innerHTML)) as IState;
} catch (err) {
	initialState = {} as IState;
}

export const getInitialState = (): IState => ({
	auth: getAuthInitialState(),
	targets: getTargetsInitialState(),
	menu: getMenuInitialState(),
	menuCatalog: getMenuCatalogInitialState(),
	...initialState,
});
